module.exports = __webpack_public_path__ + "img/logo-blanco.25ceb8ef.png";